import { dataStructure } from '@goldwasserexchange/oblis-frontend-utils';
import { createContext } from 'react';

export const highlightContext = createContext<dataStructure.accountType.listType | undefined>(undefined);
